// Convert a relative /static/... path (local-disk storage backend) into an
// absolute API URL. DO Spaces-backed uploads already return absolute
// http(s) URLs and pass through unchanged. The API and UI dev servers run
// on different origins/ports, so a bare relative path resolves against the
// wrong origin (the UI's) and 404s.
const API_BASE = (import.meta.env.VITE_API_URL ?? "")
  .replace(/\/(api\/)?v\d+\/?$/, "")
  .replace(/\/$/, "");

export const resolveLogoUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${API_BASE}${url}`;
};
